/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{top:-24px;right:4px;position:absolute;z-index:0;background-color:#ffee29;color:#2c2c2c;border-radius:4px 4px 0 0}"];
export { styles as styles };
